<template>
  <div class="banner">
    <div class="img-box">
      <el-image
        style="width: 100%"
        :src="require('@/assets/images/banner.jpg')"
      ></el-image>
    </div>
    <p class="letter">BLOCKCHAIN</p>
    <div class="info-box">
      <h3>安全守护<br />追溯到产品源头</h3>
      <p>为消费者 监管部门 企业等多方服务<br />让消费者吃上放心猪肉</p>
      <div class="input-wrap d-flex align-center">
        <el-input
          class="input"
          v-model="searchVal"
          placeholder="请输入溯源查询码进行查询"
        ></el-input>
        <el-button type="primary" @click='chauxn'>查询</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchVal: ''
    }
  },
   methods:{
        chauxn (){
           if(this.searchVal){             
             this.$router.push({path: '/search?sourceCode='+this.searchVal});
           }else{             
               alert('溯源码不可为空')
           }
        }
    }
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  max-height: 9.375rem;
  .img-box {
    position: relative;
    z-index: -1;
  }
  .letter {
    position: absolute;
    top: 1.55rem;
    left: 4.5625rem;
    z-index: 1;
    font-size: 1.125rem;
    color: rgba(67, 113, 235, 0.27);
  }
  .info-box {
    position: absolute;
    top: 2.125rem;
    left: 4.45rem;
    z-index: 2;
    color: #fff;
    h3 {
      line-height: 1rem;
      font-size: 0.8rem;
      margin-bottom: 0.375rem;
    }
    p {
      line-height: 0.625rem;
      font-size: 0.425rem;
      margin-bottom: 0.375rem;
    }
    .input-wrap {
      .input {
        font-size: 0.2rem;
        ::v-deep .el-input__inner {
          height: 0.75rem;
          line-height: 0.75rem;
          border: none;
          border-radius: 0;
        }
      }
      ::v-deep .el-button {
        border: none;
        border-radius: 0;
        padding: 0.275rem 0.6125rem;
        font-size: 0.2rem;
      }
    }
  }
}
</style>
